import Marionette from 'backbone.marionette'
import tagsPlaceholderTemplate from 'text-loader!templates/settings/tagsPlaceholder.html'

var TagPlaceholderView = Marionette.ItemView.extend({
  template: tagsPlaceholderTemplate
});

export default TagPlaceholderView;

